module.exports = __webpack_public_path__ + "img/progress.318cd9c9.png";